import * as types from "./consts";

export const postCreateProductRequest = (payload: object) => ({
  type: types.POST_CREATE_PRODUCT_REQUEST,
  payload,
});
